export enum SliderThemes {
  light = 'light',
  dark = 'dark',
}
